import { AuthToken } from './auth-token';
import { RefreshToken } from './refresh-token';

export class AuthInfo {
  constructor(public readonly authToken: AuthToken, public readonly refreshToken: RefreshToken) {}
}
